export function getFirstActiveBranch(data) {
  /** format of data
   *  [{bId,isActive,name,shortName}]
   * we output array of id where isActive is true
   */
  const data1 = JSON.parse(localStorage.getItem("branches"));
  if (data1 == null) return null;

  if (data == undefined || null) data = data1;
  let ind = data.findIndex((b) => {
    if (b.isActive == true) return true;
  });
  let output;
  if (ind > -1) output = data[ind];
  else output = null;
  return output;
}

export function getActiveBranchIds(data) {
  const output = [];
  data?.forEach((b) => {
    if (b.isActive) output.push(b.bId);
  });

  return output;
}

export function getActiveBranchIds1() {
  const branches = JSON.parse(localStorage.getItem("branches"));
  if (branches == null || branches == undefined) return null;
  const output = [];

  branches?.forEach((b) => {
    if (b.isActive) output.push(b.bId);
  });

  return output;
}

// this func return all brand id array whether selected or not.
export function getAllBranchIds() {
  const data = JSON.parse(localStorage.getItem("branches"));
  if (data == null || data == undefined || data == []) return null;
  const output = [];
  data?.forEach((b) => {
    output.push(b.bId);
  });

  return output;
}

export function branchDataStillValid(selectedBranches) {
  /**
    say branchesWithData is array of branches whose Data is in session storage.
     and Selected Branches is all those branches currently selected by user.
     both arrays will have branch ids.
we return true is all branch ids of selected Branches is present.
if some ids in selectedBranches is not present in branchesWIthDataStored then
we return array of those missing branches so that data can be fetched for only those ids.


branchesWithDataStored, selectedBranches

     */
  let a = [1, 2, 3, 4, 5, 6, 7];
  let b = [4, 7, 3, 5, 6, 7, 8, 9];
  const branchesWithDataStored = JSON.parse(
    sessionStorage.getItem("branchesWithDataStored")
  );
  const missingId = [];
  let allPresent = true;
  if (branchesWithDataStored == null) return selectedBranches;
  selectedBranches.forEach((id) => {
    let found = branchesWithDataStored.findIndex((item) => {
      if (item == id) return true;
    });

    if (found < 0) missingId.push(id);
  });

  if (missingId.length == 0) return true;
  else return missingId;
}

export function branchBasedFeedbackDataFilter(data, bId) {
  // this function filter all feedback wich belong of bId passes either a string or array;
  // this function doesnt segregate data.
  // data is feedback data. and bId is branch id
  // console.log(typeof bId);
  // console.log(data);
  let output;
  if (typeof bId == "object") {
    output = data.filter((item) => {
      if (bId.includes(item.admin_id)) return true;
    });
  } else {
    // console.log(bId);
    output = data.filter((item) => {
      if (item.admin_id == bId) return true;
    });
  }
  return output;
}

export function getBranchInfobyId(id) {
  const branches = JSON.parse(localStorage.getItem("branches"));

  let output = branches.find((b) => {
    if (b.bId == id) return true;
  });
  return output;
}

export function sortFeedbackDataBranchwise(data, activeBranches) {
  if (activeBranches == null || activeBranches?.length == 0) return null;
  if (data == null) return null;
  let data1 = [];
  activeBranches.forEach((id) => {
    const temp = data.filter((feedback) => {
      if (feedback.admin_id == id) {
        return true;
      }
    });
    data1.push(...temp);
  });

  return data1;
}

export function getStaffRegisterbyBid(bId) {
  const data = JSON.parse(localStorage.getItem("staffRegister"));
console.log("data", data);
console.log("bId", bId);
  const d1 = data?.findIndex((d) => {
    if (d.branchId == bId) return true;
  });
console.log("d1", d1);
  if (d1 >= 0) {
    // console.log(data[d1].staffData);
    return data[d1].staffRoll;
  } else return null;
}

// export function fetchQdataLocally(bId) {
//   const data = JSON.parse(localStorage.getItem("questions"));
//   console.log(data);
//   if (data == null) return null;
//   const output = data.filter((item) => {
//     if (item.admin_id == bId) return true;
//   });
//   return output[0];
// }
